﻿let $ = require('jquery');
let BreakpointSizer = require('../SizerBreakpoint.js');
let HorizontalGallery = require('../HorizontalGallery');

let FeaturedSponsors = function (customOptions) {
	let defaults = {
		element: null,
	};

	let options = $.extend({}, defaults, customOptions);

	if (options.element === null) {
		throw new Error('element option required');
	}
	
	new BreakpointSizer({ element: options.element });

	new HorizontalGallery({
		element: options.element
	});
};

module.exports = FeaturedSponsors;